// extracted by mini-css-extract-plugin
export var barContainer = "_2p-0";
export var extraThin = "_2p-3";
export var fillBar = "_2p-6";
export var fillContainer = "_2p-4";
export var overflow = "_2p-8";
export var overflowContainer = "_2p-5";
export var regular = "_2p-7";
export var thick = "_2p-1";
export var thin = "_2p-2";